import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { withPermissions, permissions } from '../../shared/authorization';
import columnDefinitions from '../../shared/columnDefinitions/glAccountsListPage';
import { adminPageNames, adminPageTitles } from '../shared/adminPageNames';
import config from '../../config';

import {
  sharedActions,
} from './store/actions';
import GLAccountListAdminColumnRenderer from './GLAccountListAdminColumnRenderer.component';
import AddEditModal from './addEditModal.component';
import DeleteModal from './deleteGLAccountListModal.component';
import AdminImportPage from '../shared/adminImportPage.component';
import downloadXlsx from './downloadXlsx';

const GLAccountListPage = ({
  canModifyInSelectedPeriod,
}) => {
  const generateTemplateFileName = useCallback(
    ({ periodName }) => `TLS_Balance_Sheet_Management_GL_Account_List_${periodName}`,
    []);

  const idFieldComparator = useCallback((glAccountList, importedGLAccountList) => (
    glAccountList.listName === importedGLAccountList.listName
    && glAccountList.glAccount === importedGLAccountList.glAccount
  ), []);

  return (
    <AdminImportPage
      pageName={adminPageNames.GL_ACCOUNT_LIST}
      canModify={canModifyInSelectedPeriod}
      AddEditEntityModal={AddEditModal}
      RemoveEntityModal={DeleteModal}
      adminColumnRenderer={GLAccountListAdminColumnRenderer}
      addEntityMessage="Add GL Account List"
      columnDefs={columnDefinitions}
      actions={sharedActions}
      exportToExcel={downloadXlsx}
      generateTemplateFileName={generateTemplateFileName}
      templatePath={config.templates.GL_ACCOUNT_LIST}
      comparatorConfig={{
        idField: 'periodName',
        idFieldComparator,
      }}
      pageTitle={adminPageTitles.GL_ACCOUNT_LIST}
    />
  );
};


GLAccountListPage.propTypes = {
  canModifyInSelectedPeriod: PropTypes.bool.isRequired,
};

export default withPermissions(permissions.GL_ACCOUNT_LIST_PAGE)(GLAccountListPage);
